import React, { Component } from 'react'
import includes from 'lodash/includes'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { reset } from 'redux-form'
import Rodal from 'rodal'
import interestArray from '../../../assets/interests/interestsArray.json'
import * as userProfileDuck from '../../../routes/authenticated/UserProfile/userProfileDuck'
import * as currentUserDuck from '../../../store/shared/currentUserDuck'
import * as interestSelectorDuck from './interestSelectorDuck'
import InterestOption from './InterestOption'

/**
 * @class InterestSelector
 * @description Select and modify interest
 */
export class InterestSelector extends Component {
  /**
   * @static propTypes
   */
  static propTypes = {
    closeModal: PropTypes.func.isRequired,
    currentUserSuccess: PropTypes.func.isRequired,
    isShowingModal: PropTypes.bool.isRequired,
    onClickOption: PropTypes.func.isRequired,
    performUpdateUserProfile: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    selectedOptions: PropTypes.array.isRequired,
    getFeedsData: PropTypes.func.isRequired,
  }

  /**
   * @constructor
   * @param props
   */
  constructor(props) {
    super(props)

    /**
     * @method updateInterests
     * @param interests
     */
    this.updateInterests = interests =>
      this.props
        .performUpdateUserProfile({ interests })
        .then(({ user }) => {
          this.props.currentUserSuccess(user)
          this.props.closeModal()
          this.props.reset('feedSearchForm')
        })
        .catch(() => {})
  }

  /**
   * @method render
   */
  render() {
    const { closeModal, isShowingModal, onClickOption, selectedOptions } = this.props

    const notEnoughInterests = selectedOptions && selectedOptions.length < 1

    return (
      <Rodal
        visible={isShowingModal}
        measure="%"
        width={90}
        height={90}
        customStyles={{ maxWidth: 1100 }}
        customMaskStyles={{ opacity: 0.8, backgroundColor: 'black' }}
        closeOnEsc={false}
        closeMaskOnClick={false}
        showCloseButton={false}
        onClose={closeModal}
        duration={200}
      >
        <div className="text-center" style={{ overflowY: 'auto', height: '100%' }}>
          <h4>Ready to build your feed?</h4>
          <h5 className="text-muted">
            <strong>Select 1 or more</strong> interests so we can show relevant content in your feed.
          </h5>
          {interestArray.map(interest => (
            <InterestOption
              key={interest.name}
              data={interest}
              onClick={() => onClickOption(interest.name)}
              isSelected={selectedOptions && includes(selectedOptions, interest.name)}
            />
          ))}
          <div
            style={{
              position: 'absolute',
              bottom: 0,
              right: 0,
              paddingRight: 20,
              paddingBottom: 10,
            }}
          >
            <button className="btn btn-success btn-lg" disabled={notEnoughInterests} onClick={() => this.updateInterests(selectedOptions)}>
              Done
            </button>
          </div>
        </div>
      </Rodal>
    )
  }
}

const mapStateToProps = state => ({
  isShowingModal: interestSelectorDuck.getIsShowingModal(state),
  selectedOptions: interestSelectorDuck.getSelectedOptions(state),
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      closeModal: interestSelectorDuck.closeModal,
      currentUserSuccess: currentUserDuck.currentUserSuccess,
      onClickOption: interestSelectorDuck.toggleOption,
      performUpdateUserProfile: userProfileDuck.performUpdateUserProfile,
      reset,
    },
    dispatch,
  )

export default connect(mapStateToProps, mapDispatchToProps)(InterestSelector)



// WEBPACK FOOTER //
// ./src/components/ui/InterestSelector/InterestSelector.js